module.exports = "/_next/static/images/ball-trio-levels-d402dc691e9a358208fafd15404eda1e.png";